































































































































































import Vue from 'vue'

import Artifacts from '@/components/artifacts/Artifacts.tsx'
import Editor from '@/components/artifacts/NewEditor.tsx'
import Measures from '@/survey/Measures.vue'
import Postgrest from '@/store/Postgrest.vue'
import { CURRENT_CASE, CURRENT_USER } from '@/components/Constants'

import Report from '@/components/interviews/Report.vue'
import Phq4Editor from '@/survey/measures/phq4/Editor.vue'
import Inep from '@/survey/measures/inep/Inep.vue'
import Phq9 from '@/survey/measures/phq9/Phq9.vue'
import Phq4 from '@/survey/measures/phq4/Phq4.vue'
import Pathev from '@/survey/measures/pathev/Pathev.vue'
import Lsas from '@/survey/measures/lsas/Editor.vue'
import LikertItem from '@/components/survey/LikertItem.vue'
import DisclosureSexual from '@/survey/measures/disclosure/DisclosureSexual.vue'

export default Vue.extend({
  components: {
    Measures,
    Bdi2: require('@/survey/measures/bdi2/Bdi2.vue').default,
    Eurohis: require('@/survey/measures/eurohis/Eurohis.vue').default,
    Sbqr: require('@/survey/measures/suicidal_ideation_and_behaviour/Suicidal_Ideation.vue')
      .default,
    Itq: require('@/survey/measures/itq/ITQ.vue').default,
    Gad2: require('@/survey/measures/gad2/Gad2.vue').default,
    ///Gad7: require('@/survey/measures/gad7/Gad7.vue').default,
    Mspss: require('@/survey/measures/mspss/Mspss.vue').default,
    Pcl5: require('@/survey/measures/pcl5/Pcl5.vue').default,
    Pg13: require('@/survey/measures/pg13/Pg13.vue').default,
    //Phq15: require('@/survey/measures/phq15/Phq15.vue').default,
    Pmbs: require('@/survey/measures/pmbs/Pmbs.vue').default,
    Wai: require('@/survey/measures/wai/Wai.vue').default,
    Trgi: require('@/survey/measures/trgi/Trgi.vue').default,
    Tgisrplus: require('@/survey/measures/tgisrplus/TgiSrPlus.vue').default,
    Traumaliste: require('@/survey/measures/traumaliste/Traumaliste.vue').default,
    Disclosure: require('@/survey/measures/disclosure/Disclosure.vue').default,
    DisclosureSexual: require('@/survey/measures/disclosure/DisclosureSexual.vue').default,
    Evaluation: require('@/survey/measures/evaluation/Evaluation.vue').default,
    Sewip: require('@/survey/measures/sewip/SewipPatients.vue').default,
    Phq9,
    Phq4,
    Postgrest,
    Pathev,
    Inep,
    Cdrisk10: require('@/survey/measures/cdrisk10/CD-Risk10.vue').default,
  },
  data() {
    return {
      report: {},
    }
  },
  methods: {
    logChange(state: any) {
      console.log(state)
    },
    stamp(phq9: object) {
      return Object.assign(phq9, {
        time_of_measurement: 'pre',
        case_id: this.$store.getters[CURRENT_CASE] && this.$store.getters[CURRENT_CASE].id,
        submitter_id: this.$store.getters[CURRENT_USER] && this.$store.getters[CURRENT_USER].id,
      })
    },
  },
})
